module.exports = __webpack_public_path__ + "img/DsIcon-ArrowRight.022ad352.svg";